import { render, staticRenderFns } from "./PcHeader.vue?vue&type=template&id=5f9f7830"
import script from "./PcHeader.vue?vue&type=script&lang=ts"
export * from "./PcHeader.vue?vue&type=script&lang=ts"
import style0 from "./PcHeader.vue?vue&type=style&index=0&id=5f9f7830&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_epdqlcc3dmzbifjpwlzkpsihom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports